import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bscontainer',
	templateUrl:'./BSContainerPage.html',
	styles: [],
	styleUrls:['./BSContainerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSContainerPage
{
	mdContent_95 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.containers.BSContainer;
\`\`\``;
	mdContent_96 = `\`\`\`java
new BSContainer<>()
\`\`\``;
	mdContent_97 = `\`\`\`java
new BSContainer<>(BSContainerOptions option)
\`\`\``;
	mdContent_98 = `\`\`\`java
var container = new BSContainer<>(BSContainerOptions.Container_Fluid);
var row = new BSRow<>();
row.add(new BSColumn<>().setText("Column 1"));
row.add(new BSColumn<>().setText("Column 2"));
container.add(row);
\`\`\``;
}
